module.exports = __webpack_public_path__ + "static/img/aiqing.642f6260.png";